import { render, staticRenderFns } from "./myPlanPage.vue?vue&type=template&id=05f3ceab&scoped=true&"
import script from "./myPlanPage.vue?vue&type=script&lang=ts&"
export * from "./myPlanPage.vue?vue&type=script&lang=ts&"
import style0 from "./myPlanPage.vue?vue&type=style&index=0&id=05f3ceab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f3ceab",
  null
  
)

export default component.exports